<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>Szczegóły wyrazu</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <b-form class="col-12">
        <b-form-group label="Wyrażenie">
          <b-form-input v-model="term" type="text" autocomplete="off" readonly="readonly" />
        </b-form-group>

        <b-form-group class="text-right">
          <b-button
            variant="outline-primary"
            class="btn-sm"
            @click="downloadAudio(term, partOfSpeech)"
          >
            <font-awesome-icon icon="download" class="fa-fw"></font-awesome-icon>&nbsp; Pobierz ze słownika LEXICO (Oxford)
          </b-button>
        </b-form-group>

        <b-form-group label="Część mowy">
          <b-form-select v-model="partOfSpeech" :options="partOfSpeechOptions" disabled="disabled" />
        </b-form-group>

        <b-form-group label="Tłumaczenie">
          <b-form-input v-model="translation" type="text" autocomplete="off" readonly="readonly" />
        </b-form-group>

        <b-form-group label="Wymowa">
          <b-form-input v-model="pronunciation" type="text" autocomplete="off" readonly="readonly" />
        </b-form-group>

        <b-form-group label="Przykładowe zdanie">
          <b-form-input
            v-model="exampleSentence"
            type="text"
            autocomplete="off"
            readonly="readonly"
          />
        </b-form-group>

        <b-form-group label="Zdanie do wypełnienia (ćwiczenie)">
          <b-form-input
            v-model="exerciseSentence"
            type="text"
            autocomplete="off"
            readonly="readonly"
          />
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            switch
            v-model="caseSensitive"
            disabled="disabled"
          >Uwzględniaj wielkość znaków przy wykonywaniu ćwiczeń</b-form-checkbox>
        </b-form-group>

        <b-form-group label="Audio" class="audioGroup d-flex flex-column">
          <div v-if="audioFileId" class="flex-row">
            <div style="margin-bottom: 4px;">
              <audio controls controlslist="nodownload">
                <source :src="audioFileUrl" />Twoja przeglądarka nie wspiera elementu audio.
              </audio>
            </div>
            <div>
              <button class="btn btn-sm btn-outline-info" @click.prevent="download(audioFileId)">
                <font-awesome-icon icon="download" class="fa-fw"></font-awesome-icon>
              </button>
            </div>
          </div>
        </b-form-group>
        <b-form-group label="Obraz" class="imageGroup d-flex flex-column">
          <div v-if="imageFileId" class="flex-row">
            <img :src="imageFileUrl" style="max-width: 600px; padding-bottom: 8px;" />
            <br />
            <button class="btn btn-sm btn-outline-info" @click.prevent="download(imageFileId)">
              <font-awesome-icon icon="download" class="fa-fw"></font-awesome-icon>
            </button>
          </div>
        </b-form-group>
        <b-form-group class="text-right">
          <hr />
          <b-button class="mr-1" variant="secondary" @click="$router.go(-1)">Powrót</b-button>
        </b-form-group>
      </b-form>
    </b-row>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";

export default {
  data() {
    return {
      wordId: this.id,
      saving: false,
      audioFile: null,
      imageFile: null,
      term: null,
      translation: null,
      pronunciation: null,
      partOfSpeech: null,
      partOfSpeechOptions: [
        { value: null, text: "" },
        { value: 1, text: "czasownik regularny" },
        { value: 2, text: "czasownik nieregularny" },
        { value: 6, text: "czasownik frazalny" },
        { value: 7, text: "idiom" },
        { value: 3, text: "przymiotnik" },
        { value: 4, text: "przysłówek" },
        { value: 0, text: "rzeczownik" },
        { value: 8, text: "wyrażenie" },
        { value: 5, text: "zaimek" }
      ],
      exampleSentence: null,
      caseSensitive: false,
      exerciseSentence: null,
      audioFileId: null,
      imageFileId: null
    };
  },
  props: ["id"],
  computed: {
    imageFileUrl() {
      return axios.getFileUrl(this.imageFileId);
    },
    audioFileUrl() {
      return axios.getFileUrl(this.audioFileId);
    }
  },
  mounted() {
    if (this.id) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });
      axios
        .get("/words/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;
          this.term = result.term;
          this.caseSensitive = result.caseSensitive;
          this.translation = result.translation;
          this.pronunciation = result.pronunciation;
          this.audioFileId = result.audioId;
          this.imageFileId = result.imageId;
          this.exampleSentence = result.exampleSentence;
          this.exerciseSentence = result.exerciseSentence;
          this.partOfSpeech = result.partOfSpeech;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    }
  },
  methods: {
    goto(url) {
      this.$router.push(url);
    },
    downloadAudio(term, partOfSpeech) {
      axios
        .get("/words/audio", {
          responseType: "blob",
          params: {
            term: term,
            partOfSpeech: partOfSpeech
          }
        })
        .then(response => {
          var result = response.data;
          const url = window.URL.createObjectURL(new Blob([result]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${term}.mp3`);

          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          alert("x");
          eventBus.$emit(
            "unhandled-error",
            "Nie udało się pobrać pliku audio ze słownika"
          );
        })
        .then(() => {});
    },
    async download(fileId) {
      if (fileId) {
        var fileDtoResponse = await axios.get("/files", {
          params: {
            id: fileId
          }
        });

        let fileDto = fileDtoResponse.data;
        window.console.log(fileDto);
        if (fileDto) {
          let result = await axios.downloadFileAsync(fileId);
          const url = window.URL.createObjectURL(new Blob([result]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", fileDto.fullName);

          document.body.appendChild(link);
          link.click();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}

.audioGroup {
  div.flex-row {
    margin-bottom: 10px;
  }

  margin-bottom: 0px;

  button {
    margin-right: 5px;
    border-radius: 5px;
  }
}
</style>